import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import UserBalance from '../../components/_molecules/UserBalance/UserBalance';
import './BalanceScreen.scss';
import RefillBalance from '../../components/_molecules/RefillBalance/RefillBalance';
import { LOADING, ERROR, SUCCESS, publicHash } from '../../utils/constants';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';
import SuccessModal from '../../components/_molecules/SuccessModal/SuccessModal';
import UserCardInfo from '../../components/_molecules/UserCardInfo/UserCardInfo';
import UserInvoiceInfo from '../../components/_molecules/UserInvoiceInfo/UserInvoiceInfo';
import Button from '../../components/_atomic/Button/Button';
import UserBalanceHistory from '../../components/_molecules/UserBalanceHistory/UserBalanceHistory';

//

class BalanceScreen extends Component {
  static propTypes = {
    balance: PropTypes.shape({
      amount: PropTypes.number,
    }).isRequired,
    refillBalance: PropTypes.func.isRequired,
    refillBalanceStatus: PropTypes.string.isRequired,
    refillBalanceError: PropTypes.string.isRequired,
    annulStoreErrors: PropTypes.func.isRequired,
    getProfile: PropTypes.func.isRequired,
    cardMethod: PropTypes.shape({}).isRequired,
    invoiceMethod: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    getProfileStatus: PropTypes.func.isRequired,
    getBalanceHistory: PropTypes.func.isRequired,
    balanceHistory: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasMoreBalanceHistory: PropTypes.bool.isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    balanceHistoryPage: PropTypes.number.isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaignsStatus: PropTypes.string.isRequired,
  };
  state = {
    isFirstRefill: false,
  };
  componentWillMount() {
    if (this.props.history.location.pathname.indexOf('refill') > -1) {
      this.setState(() => ({
        isFirstRefill: true,
      }));
      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => {
        window.history.go(1);
      };
    }
  }
  componentDidUpdate(prevProps) {
    const { getProfile, refillBalanceStatus } = this.props;
    if (
      refillBalanceStatus !== prevProps.refillBalanceStatus &&
      refillBalanceStatus === SUCCESS
    ) {
      getProfile();
    }
  }

  navigateToChange = () => {
    const { isFirstRefill } = this.state;
    if (isFirstRefill) {
      this.props.history.push(`${publicHash}/app/add-payment`);
    } else {
      this.props.history.push(`${publicHash}/app/update-payment`);
    }
  }

  navigateToApp = () => {
    this.props.history.push(`${publicHash}/app`);
  };
  render() {
    const {
      balance: { amount },
      refillBalance,
      refillBalanceStatus,
      refillBalanceError,
      annulStoreErrors,
      cardMethod,
      invoiceMethod,
      getProfileStatus,
      getBalanceHistory,
      balanceHistory,
      hasMoreBalanceHistory,
      balanceHistoryPage,
      apps,
      getAppCampaigns,
      currentAppCampaigns,
      getAppCampaignsStatus,
    } = this.props;
    const { isFirstRefill } = this.state;
    const balanceScreenClasses = classNames({
      screen: true,
      'balance-screen': true,
    });
    const isLoading = refillBalanceStatus === LOADING;
    const isError = refillBalanceStatus === ERROR;
    const isSuccess = refillBalanceStatus === SUCCESS;
    return (
      <div className={balanceScreenClasses}>
        <LoadingOverlay visible={isLoading} />
        <ErrorModal
          visible={isError}
          error={refillBalanceError}
          requestClose={annulStoreErrors}
        />
        <SuccessModal
          visible={isSuccess}
          text="Your balance successfully refilled"
          buttonClick={annulStoreErrors}
        />
        <div className="main-label-no-transform">
          <span>Financial Info</span>
        </div>
        <div className="top-wrapper">
          <UserBalance amount={amount} />
          {cardMethod.active && (
            <RefillBalance
              refillBalanceStatus={refillBalanceStatus}
              refillBalance={refillBalance}
            />
          )}
          <div className="billing-info-wrapper">
            <div className="middle-text">
              <span>Billing Info</span>
            </div>
            {cardMethod.active && (
              <UserCardInfo
                clickChangeHandler={this.navigateToChange}
                lastFour={cardMethod.lastFour}
              />
            )}
            {invoiceMethod.active && (
              <UserInvoiceInfo
                invoiceMethod={invoiceMethod}
                clickChangeHandler={this.navigateToChange}
              />
            )}
            {isFirstRefill && (
              <div className="button-wrapper">
                <Button label="Finish" clickHandler={getProfileStatus} />
              </div>
            )}
          </div>
        </div>
        {!isFirstRefill && <UserBalanceHistory
          hasMoreBalanceHistory={hasMoreBalanceHistory}
          balanceHistory={balanceHistory}
          getBalanceHistory={getBalanceHistory}
          apps={apps}
          page={balanceHistoryPage}
          refillBalanceStatus={refillBalanceStatus}
          getAppCampaigns={getAppCampaigns}
          currentAppCampaigns={currentAppCampaigns}
          getAppCampaignsStatus={getAppCampaignsStatus}
        /> }
      </div>
    );
  }
}

export default BalanceScreen;



// WEBPACK FOOTER //
// ./src/containers/BalanceScreen/BalanceScreen.js